import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import useFetch from 'use-http';
import Page from '@/v2/components/Page';
import Container from '@/components/shared/Container';
import { SimpleServiceCard } from '@/v2/components/SimpleServiceCard/SimpleServiceCard';
import NoResults from '@/components/shared/NoResults/NoResults';
import { exponeaCapture } from '@/components/hooks/exponeaCapture';
import ServicesContainer from './Components/ServicesContainer';
import { useCartData } from '../CartPage/context/CartDataContext';
import Loader from '@/v2/components/Loader';
import InlineLoader from '@/components/shared/InlineLoader/InlineLoader';
import { buildCouponTrackingData, pushEcommerceItemEvent } from '../../utils/bookingTracking';

const CouponServicePage = () => {
  const { search: urlParams } = useLocation();
  const history = useHistory();
  const options = queryString.parse(urlParams);

  const { get, loading: loadingCoupons } = useFetch(
    '/CouponManagement/GetCoupons',
  );
  const [data, setData] = useState();
  const { setCoupon } = useCartData();

  useEffect(() => {
    get().then((res) => setData(res));
  }, [get]);

  useEffect(() => {
    let exponea = JSON.parse(sessionStorage.getItem('exponeaTrack') || '[]');
    if (exponea.length > 0) {
      exponea.push({ name: 'Registration status', value: 'Cancelled' });
      exponea.push({ name: 'booking_stage', value: 'Cancelled' });
      exponeaCapture(exponea, 'booking');
      sessionStorage.removeItem('exponeaTrack');
    }

    exponeaCapture(
      [
        { name: 'category_1', value: 'Dovanų kuponai' },
        { name: 'category_id', value: '3' },
      ],
      'view_item',
    );
  }, []);

  return (
    <Page error={!loadingCoupons && !data} loading={loadingCoupons}>
      <ServicesContainer marginTop={true}>
        <Page.Title backUrl={`/`} greyTheme={true} smallHeight={true}>
          Dovanų kuponai
        </Page.Title>
      </ServicesContainer>

      <ServicesContainer>
        {loadingCoupons ? (
          <div className="relative h-[400px]">
            <InlineLoader light={true} />
          </div>
        ) : data && data.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
            {data.map((coupon, i) => (
              <SimpleServiceCard
                key={i}
                serviceTitle={`DOVANŲ KUPONAS ${coupon.price} Eur`}
                validity={
                  Number.isFinite(coupon?.validationTimeInDays)
                    ? Math.round((coupon.validationTimeInDays / 365) * 12)
                    : null
                }
                price={`${coupon.price.toFixed(2)} €`}
                urlParams={urlParams}
                onSelect={() => {
                  const tracking = buildCouponTrackingData({ coupon });
                  pushEcommerceItemEvent('view_item', tracking);
                  pushEcommerceItemEvent('add_to_cart', tracking);
                  setCoupon(coupon);
                  history.push('/dovanu-kuponai/cart');
                }}
              />
            ))}
          </div>
        ) : (
          <NoResults>Paieškos rezultatų nėra</NoResults>
        )}
      </ServicesContainer>
    </Page>
  );
};

export default CouponServicePage;
